import { Center, Stack, Text, Title } from '@mantine/core';
import { IconMailCheck } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

/**
 * @desc The legacy site's post-signup redirect target (spec: "Redirect landing before invitation
 * acceptance"). Deliberately public and unauthenticated: the user has just been provisioned and
 * has not opened their invitation yet, so sending them at the sign-in flow would be a dead end.
 *
 * Once they accept the invitation and sign in, the `_protected` guard's holding screen takes over
 * as the held state — this route only covers the gap before an account can sign in at all.
 */
export const Route = createFileRoute('/waiting')({
  component: WaitingPage,
});

function WaitingPage() {
  return (
    <Center h="100dvh" p="md" data-testid="waiting-landing">
      <Stack align="center" gap="sm" maw={440} ta="center">
        <IconMailCheck size={48} stroke={1.5} />
        <Title order={3}>Check your email</Title>
        <Text c="dimmed" size="sm">
          Your H2GC beta account has been created. We&rsquo;ve emailed you an invitation &mdash;
          open it to set your password and sign in.
        </Text>
        <Text c="dimmed" size="sm">
          Access is reviewed by an H2 administrator, so there may be a short wait after you sign in
          before the app opens.
        </Text>
        <Text c="dimmed" size="sm">
          No email after a few minutes? Check your spam folder, or contact info@h2gc.com.
        </Text>
      </Stack>
    </Center>
  );
}
